/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Star24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Star 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M16.838 6.243 14.863 2.27c-1.173-2.36-4.552-2.36-5.726 0L7.162 6.243l-4.422.638C.134 7.257-.947 10.466.972 12.323l3.19 3.088-.752 4.357c-.455 2.634 2.316 4.574 4.631 3.365L12 21.067l3.959 2.066c2.315 1.209 5.086-.73 4.63-3.365l-.752-4.357 3.191-3.088c1.92-1.857.838-5.066-1.768-5.442l-4.422-.638Zm-3.766-3.082c-.438-.883-1.706-.883-2.144 0L8.764 7.513c-.174.35-.511.594-.9.65l-4.839.698c-.98.141-1.372 1.338-.663 2.025l3.502 3.388c.281.273.41.665.343 1.05l-.826 4.785c-.168.97.858 1.709 1.735 1.251l4.328-2.259a1.204 1.204 0 0 1 1.112 0l4.328 2.259c.877.458 1.903-.282 1.735-1.251l-.826-4.785a1.181 1.181 0 0 1 .344-1.05l3.5-3.388c.71-.687.319-1.884-.662-2.025l-4.839-.698a1.195 1.195 0 0 1-.9-.65l-2.164-4.352Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Star24,
  md: Star24,
  lg: Star24,
  xl: Star24,
  xxl: Star24,
  xxxl: Star24,
};

export const StarIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'star-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
